import { Component, OnInit } from '@angular/core';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-financial',
  templateUrl: './financial.component.html',
  styleUrls: ['./financial.component.css']
})
export class FinancialComponent implements OnInit {

  constructor(private mds: MetaService) { }

  ngOnInit(): void {
    //SEO Optimization
    var strTitle = 'RegScale - Financial';
    var description = 'RegScale solutions for Financial Institutions (FIs) - audit management, 3rd party vendor risk, and compliance';
    var keywords = 'RegScale, Financial Institutions (FIs), compliance, audits, banking, insurance, mortgage, investors, credit unions, FDIC, FSSC, PCI, CFPB, NCUA, SEC';
    this.mds.updateTags(strTitle, keywords, description);
  }

}
